module.exports = __webpack_public_path__ + "fonts/icomoon.5b9d677.ttf";